import type { PageComponentProps } from '@/features/a-dynamic-page/components/page-component-switch';
import type { MapButtonStickyV1Attributes } from '@/features/map/map-button-sticky-v1/map-button-sticky-v1-type';

import MapButtonSticky from '@/features/map/map-button-sticky-v1/map-button-sticky';
import useMapOverlayHistoryState from '@/features/map/map-container/use-map-overlay-history';

export default function MapButtonStickyV1({ attributes }: PageComponentProps<MapButtonStickyV1Attributes>) {
    const { iconUrl, linkUrl, title } = attributes;

    const { openOverlay } = useMapOverlayHistoryState();

    return (
        <MapButtonSticky
            iconUrl={iconUrl}
            linkUrl={linkUrl}
            onClick={linkUrl ? undefined : openOverlay}
            position={'fixed'}
            title={title}
        />
    );
}
